"use client";

import { cn, Select, SelectItem } from "@kyan/ui";
import React from "react";

import { nextMaturities } from "#/utils/maturities";
import { parseMaturity } from "#/utils/maturity";

export interface MaturitySelectorProps {
  value: string;
  className?: string;
  onChange?: (value: string) => void;
}

export const MaturitySelector: React.FC<MaturitySelectorProps> = ({
  value,
  className,
  onChange,
}) => {
  return (
    <Select
      tabIndex={-1}
      value={value}
      viewportClassName="max-h-56"
      triggerClassName={cn("h-8 text-xs", className)}
      onValueChange={onChange}
    >
      {nextMaturities().map((item) => (
        <SelectItem showCheck key={item} value={item} className="h-8 text-xs">
          {parseMaturity(item)}
        </SelectItem>
      ))}
    </Select>
  );
};
